<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-6 col-md-12 col-2 mb-3">
                    <h2>Process Tickets</h2>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
                        <ol class="breadcrumb breadcrumb-links breadcrumb-dark">
                        <li class="breadcrumb-item cursor-pointer" @click="getFiles()" >
                            <i class="fas fa-home"></i>
                        </li>
                        <li class="breadcrumb-item cursor-pointer" @click="menuClicked(menuName)"  v-for="menuName in navMenus" :key="menuName">{{ menuName }}</li>
                        </ol>
                    </nav>
                    </div>
                </div>
                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6" >
            <div class="row">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive" style="min-height:200px">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <!-- {{ currentPreFixName }} -->
                        <table class="table align-items-center table-flush table-hover bidtbl" style="min-height:125px">
                            <thead class="thead-light psticky">
                            <tr>
                                <th 
                                    scope="col" 
                                    class="sort"
                                     >Name</th>                  
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="filesList.length == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="data in filesList" :key="data.id">
                                <td v-if="data.Prefix" class="text-primary cursor-pointer" @click="getFiles(data.Prefix)">
            
                                    <i class="fas fa-folder-open"></i><span class="object-name">{{data.PrefixDisplayName}}</span>
                                  
                                </td>
                                <td v-if="data.Key" class="text-primary cursor-pointer" @click="downloadFile(data.Key)">
                                    <i class="fa fa-file"></i><span class="object-name"> {{data.KeyDisplayName}} </span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="total-records">
                            <span>Total Records : {{filesList.length}}</span>
                        </div> 
                        </div>
                    </div>
                    </div>
            </div>
        </div>
    </div>      
</template>
<script>
import AWS from 'aws-sdk/global';
import config from "@/config";
import authService from "@/authService";

export default {
  name: "unprocessed",
  components : {
    
  },
  data() {
    return {
        filesList : [],
        accessToken : null,
        loading: false,
        processing : false,
        currentPreFixName : "ticket_catalogue/catalogue/",
        navMenus : []

    };
  },
  methods: {

    menuClicked(currentMenu){
        //console.log(this.currentPreFixName.split(currentMenu))
        let path = this.currentPreFixName.split("/"+currentMenu)[0]+"/"+currentMenu+"/";
        console.log(path)
        this.getFiles(path);
    },
    setNavMenu(){
        let menuString = this.currentPreFixName.split('ticket_catalogue/catalogue/').pop();
        this.navMenus = [];
        this.navMenus = menuString.split("/")
    },
    downloadFile(downloadKey){
      this.loading = true;
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .post(
           config.baseUrlBidSide +
            "/fileupload/get-file",{
                    "key":downloadKey
                },
            auth
        )
        .then((response) => {
          window.open(response.data, "_blank");
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          //Error Occured so forcefully logged out 
          this.loading = false;

        });
    },
    getFiles(preFixName){
        let self = this;
        var s3 = new AWS.S3({
            apiVersion: "2006-03-01",
            params: { Bucket: "imsfileupload"}
        });
        if(preFixName){
            this.currentPreFixName = preFixName;
        }else{
            this.currentPreFixName = "ticket_catalogue/catalogue/";
        }
        this.setNavMenu();
        var params = {
            Bucket: config.albumBucketNameIms, /* required */
            Prefix: this.currentPreFixName,  
            Delimiter: '/'
        };
        self.loading = true
        s3.listObjectsV2(params, function(err, data) {
            if (err) {
                self.$alert("File upload session expired. Please try again.","","error").then(() => {
                    window.location.reload()
                })
                console.log(err, err.stack);self.loading = false
            } // an error occurred
            else {
                
                if(data.CommonPrefixes.length > 0){
                    let outPut = [];
                     data.CommonPrefixes.forEach(element => {
                        element.PrefixDisplayName = element.Prefix.split(self.currentPreFixName).pop();
                        outPut.push(element)
                    });
                    self.filesList = outPut;
                }
                if(data.Contents.length > 0){
                    let outPut = [];
                     data.Contents.forEach(element => {
                        element.KeyDisplayName = element.Key.split(self.currentPreFixName).pop();
                        outPut.push(element)
                    });
                    self.filesList = outPut;
                }
                self.loading = false

            }     
        });
    }
   
  },
  mounted() {
      this.loading = true;
      let self = this;
      this.$cognitoAuth.getIdToken((err, result) => {
          if (err) {
              console.log("accessToken is not found", err);
          } else {
              this.accessToken = result;
          }
      });
      const userPoolLoginKey = config.userPoolLoginKey;
      const logins = {};
      logins[userPoolLoginKey] = this.accessToken;
      AWS.config.region = config.region;
      const cognitoParams = {
          IdentityPoolId: config.IdentityPoolIdFileUpload,
          Logins: logins
      };
      let cognitoidentity = new AWS.CognitoIdentity();
      cognitoidentity.getId(cognitoParams, function(err, data) {
          if (err) {
              console.log(err);
              self.$alert("File upload session expired. Please try again.","","error").then(() => {
                    window.location.reload()
                })
          } else {
              console.log(data.IdentityId);
              let bucketRegion = AWS.config.region;
              AWS.config.update({
              region: bucketRegion,
              credentials: new AWS.CognitoIdentityCredentials(cognitoParams)
              });
              self.getFiles();
          }
      });
      
    }
};
</script>
<style scoped>
.table i{
    color: #0073bbc7;

}
.object-name{
    padding: 7px;
    font-size: 13px;
    color: #0073bbc7;
}
</style>